import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchGetConcerts(action) {
	try {
		const result = yield fromApi.dataConcertsGets(action.page, action.range, action.cat, action.dep).then((data) => {
			return data;
		});
		yield put({type: 'GET_CONCERTS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetConcert(action) {
	try {
		const result = yield fromApi.concertGet(action.payload).then((data) => {
			return data;
		});
		yield put({type: 'GET_CONCERT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutConcert(action) {
	try {
		const result = yield fromApi.concertPut(action.payload, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_CONCERT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelCONCERT(action) {
	try {
		const result = yield fromApi.paDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_PA_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* concerts() {
	yield takeLatest('GET_CONCERTS_SAGAS', watchGetConcerts);
	yield takeLatest('GET_CONCERT_SAGAS', watchGetConcert);
	yield takeLatest('PUT_CONCERT_SAGAS', watchPutConcert);
	yield takeLatest('DEL_CONCERT_SAGAS', watchDelCONCERT);
}

export default function* rootSaga() {
	yield all([concerts()]);
}
